import React, { useRef } from 'react';
import { IActionLinkItem, IActionLinksModel } from './ActionLinkModels';
import { ActionLink } from './ActionLink';
import { ActionLinks } from './ActionLinks';
import { IActionHoverHandler } from './hooks/ShowsNestedOnHover';
import { Placement } from 'popper.js';
import { Callout } from '../layout/Callout';
import { Icon } from 'components/icons/Icon';

interface IActionLinkGroupProps extends IActionLinksModel {
  groupLabel: string;
  callback?: (value: string | number) => void;
  level: number;
  onMouseOver: IActionHoverHandler;
  hoveredLabel: string;
  direction?: Placement; // TODO, this and tweak the direction of the expand arrow
  afterLabels?: (linkProps: IActionLinkItem) => React.ReactNode;
}

/**
 * A group of Action links hidden behind a group heading or category.
 *
 * e.g. "Converters" for Mapping Type Selectors.
 *
 * Copyright (c) 2019 Decisions All Rights Reserved
 */
export function ActionLinkGroup({
  afterLabels,
  groupLabel,
  callback,
  values,
  level,
  onMouseOver: onGroupHover,
  hoveredLabel,
  direction = 'left',
}: IActionLinkGroupProps) {
  const ref: React.MutableRefObject<any> = useRef(null);
  const onClose = () => {}; //??
  const groupHovered = hoveredLabel === groupLabel;
  return (
    <>
      <ActionLink
        value={groupLabel}
        label={groupLabel}
        onMouseOver={onGroupHover}
        className={hoveredLabel === groupLabel ? 'dpc-action-link--open-group' : undefined}
        ref={ref}
        afterLabel={
          <Icon className="dp-icon--collapsed-dark dpc-action-links__expand-icon" inline={true} size="small" />
        }
      />
      {values && (
        <Callout isOpen={groupHovered} onClose={onClose} sourceRef={ref} depth={level} placement={direction}>
          <ActionLinks
            key={groupLabel + 1}
            level={level}
            values={values}
            callback={callback}
            placement={direction}
            afterLabels={afterLabels}
          />
        </Callout>
      )}
    </>
  );
}
